<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>人员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="关键字" prop="name">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="输入姓名或手机号进行搜索"
              @keyup.enter.native="query()"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="name">
            <el-select
              style="width: 100%"
              v-model="filter.role_name"
              size="small"
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in allRoles"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="small" @click="query()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
        v-permission="Auth.userNew"
        >新增人员</el-button
      >
      <el-table v-if="!isMobile()" :data="staffs" stripe style="width: 100%">
        <el-table-column prop="name" label="姓名（中文名）" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.name }}（{{ scope.row.name_en || '-' }}）
            <div>
              <el-tag
                size="mini"
                type="primary"
                class="mr-5"
                v-for="item in scope.row.departments"
                :key="item"
                >{{ DepartmentCategoryMap[item] }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone_number"
          label="手机号"
          align="left"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="email"
          label="邮箱"
          min-width="160"
        ></el-table-column>

        <el-table-column label="角色" align="left" min-width="120">
          <template slot-scope="scope">{{
            showRoles(scope.row.auth_roles)
          }}</template>
        </el-table-column>
        <el-table-column
          label="区域 / 城市"
          align="center"
          v-if="auth.isPlatformUser()"
        >
          <template slot-scope="scope">
            {{ AreaTextMap[scope.row.area_id] || '-' }}<br />
            {{ CodeToText[scope.row.province] }}{{ CodeToText[scope.row.city] }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="销售组"
          prop="group.name"
          align="center"
          v-if="!auth.isPlatformUser()"
        ></el-table-column> -->
        <el-table-column
          v-if="auth.isPlatformUser()"
          align="center"
          prop="c4c_id"
          label="C4C ID"
        ></el-table-column>
        <!-- <el-table-column label="简称" align="center" prop="contraction">
          <template slot="header">简称<CustomTip :t="2"></CustomTip></template>
        </el-table-column> -->
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 1 ? 'success' : 'gray'"
              :name="scope.row.status == 1 ? '已启用' : '已禁用'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="260">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.userStatus"
              :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ scope.row.status == 1 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.userEdit"
              >编辑</el-button
            >
            <router-link
              :to="'/dashboard/admin/users/' + scope.row.id"
              v-permission="Auth.userShow"
            >
              <el-button class="ml-10" type="primary" plain size="mini"
                >详情</el-button
              >
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style mt-5">
        <li v-for="(staff, index) in staffs" class="flex-row-between">
          <div>
            <div>
              {{ staff.name }}
              <span v-if="auth.isPlatformUser()"
                >（ {{ AreaTextMap[staff.area_id] }}
                {{ CodeToText[staff.province] }}{{ CodeToText[staff.city] }}
                ）
              </span>

              <!-- <div> -->
              <el-tag
                size="mini"
                type="primary"
                class="mr-5"
                v-for="item in staff.departments"
                :key="item"
                >{{ DepartmentCategoryMap[item] }}</el-tag
              >
              <!-- </div> -->
            </div>
            <div v-if="staff.status != 1">
              <status-tag
                :type="staff.status == 1 ? 'success' : 'gray'"
                :name="staff.status == 1 ? '已启用' : '已禁用'"
              ></status-tag>
            </div>
            <a :href="'tel:' + staff.phone_number">{{ staff.phone_number }}</a>
            <div>{{ staff.email }}</div>
            <div>{{ showRoles(staff.auth_roles) }}</div>
          </div>
          <div class="mt-5">
            <el-popconfirm
              v-permission="Auth.userStatus"
              :title="`确认${staff.status == 1 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(index, staff.id)"
            >
              <el-button
                slot="reference"
                :type="staff.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ staff.status == 1 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(index, staff)"
              v-permission="Auth.userEdit"
              >编辑</el-button
            >
            <router-link
              :to="'/dashboard/admin/users/' + staff.id"
              v-permission="Auth.userShow"
            >
              <el-button class="ml-10" type="primary" plain size="mini"
                >详情</el-button
              >
            </router-link>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <user-former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></user-former>
    </div>
  </div>
</template>

<script>
import { userList, switchUserStatus, roleList } from '@/service/getData'
import { isMobile } from '@/util/index'
import auth from '../../util/auth'

import UserFormer from './former'
import { AreaTextMap, DepartmentCategoryMap } from '@/config/global'
import { CodeToText } from '@/util/area_tool'

export default {
  components: {
    UserFormer,
  },
  watch: {
    'filter.page': function () {
      this.getUsers()
    },
  },
  data() {
    return {
      DepartmentCategoryMap,
      AreaTextMap,
      CodeToText,
      model: {},
      auth,
      filter: {
        page: 1,
        size: 20,
        query: '',
        role_name: '',
      },
      allRoles: [],
      total: 0,
      editIndex: 0,
      isMobile,
      staffs: [],
      dialogVisible: false,
    }
  },
  created() {
    this.getUsers()
    this.getRoles()
  },
  methods: {
    query() {
      this.filter.page = 1
      this.getUsers()
    },
    async getUsers() {
      let data = {
        all_status: true,
        size: this.filter.size,
        page: this.filter.page - 1,
        query: this.filter.query,
        role_name: this.filter.role_name,
        all_resource: true,
      }
      let res = await userList(data)
      if (res.code == 0) {
        this.staffs = res.data.list
        this.total = res.data.total
      }
    },
    showRoles(roles) {
      if (!roles) return ''
      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },
    createdCallback(data) {
      this.staffs.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.staffs, this.editIndex, data)
    },
    handleNew() {
      this.model = {
        name: '',
        name_en: '',
        email: '',
        phone_number: '',
        roles: [],
        area_id: '',
        group_id: '',
        departments: [],
        area: [],
        c4c_id: '',
        contraction: '',
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      let roles = item.auth_roles
        ? item.auth_roles.map((item) => {
            return item.id
          })
        : []
      this.dialogVisible = true
      this.$nextTick(() => {
        let area = []
        if (item.province) {
          area.push(item.province)
        }
        if (item.city) {
          area.push(item.city)
        }
        this.model = {
          id: item.id,
          name: item.name,
          name_en: item.name_en,
          email: item.email,
          c4c_id: item.c4c_id,
          roles: roles,
          departments: item.departments,
          phone_number: item.phone_number,
          group_id: item.group_id == 0 ? '' : item.group_id,
          area_id: item.area_id == 0 ? '' : item.area_id,
          area: area,
          contraction: item.contraction,
        }
        this.editIndex = index
      })
    },
    async handleSwitchStatus(index, id) {
      let res = await switchUserStatus(id)
      if (res.code == 0) {
        this.staffs[index].status = res.data.status
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.allRoles = res.data.list.filter((item) => item.status == 1)
      }
    },
    reset() {
      this.filter.page = 1
      this.filter.role_name = ''
      this.filter.query = ''
      this.getUsers()
    },
  },
}
</script>

<style scoped>
.long {
  width: 100%;
}

.flex-row-between {
  flex-direction: column;
  align-items: flex-start;
}
</style>
